export const BRAIN_SAFETY_LOCATION_OPTIONS = [
    'Basal ganglia Left',
    'Basal ganglia Right',
    'Cerebellar hemisphere Left',
    'Cerebellar hemisphere Right',
    'Cerebellar vermis',
    'Corpus callosum - body',
    'Corpus callosum - genu',
    'Corpus callosum - splenium',
    'Fourth ventricle',
    'Frontal lobe Left',
    'Frontal lobe Right',
    'Insula Left',
    'Insula Right',
    'Lateral ventricle Left',
    'Lateral ventricle Right',
    'Left leptomeningeal Left',
    'Left leptomeningeal Right',
    'Medulla',
    'Midbrain',
    'Occipital lobe Left',
    'Occipital lobe Right',
    'Parietal lobe Left',
    'Parietal lobe Right',
    'Pineal region',
    'Pons',
    'Sella / pituitary',
    'Skull / calvarium Left',
    'Skull / calvarium Right',
    'Temporal lobe Left',
    'Temporal lobe Right',
    'Thalamus Left',
    'Thalamus Right',
    'Other (specify)',
];

const LOCATION_FINDING_KEYS = [
    'macrohemorrhages',
    'lacunarInfarcts',
    'largeVesselTerritorialInfarctions',
    'vasogenicEdema',
    'acuteIschemia',
];

const ABNORMALITY_FINDING_KEYS = [
    'tumor',
    'hydrocephalus',
    'vascularMalformation',
];

export function normalizeBrainSafetyLocation(value: any): string[] {
    const values = Array.isArray(value) ? value : [value];
    const normalized: string[] = [];

    values.forEach((candidate) => {
        if (typeof candidate !== 'string') {
            return;
        }

        const trimmedCandidate = candidate.trim();
        const canonicalValue = BRAIN_SAFETY_LOCATION_OPTIONS.find(
            option => option.toLowerCase() === trimmedCandidate.toLowerCase()
        );

        if (canonicalValue && !normalized.includes(canonicalValue)) {
            normalized.push(canonicalValue);
        }
    });

    return normalized;
}

export function normalizeBrainSafetySavedScoring(savedScoring: any): any {
    if (!savedScoring || typeof savedScoring !== 'object') {
        return savedScoring;
    }

    const safetyAssessment = savedScoring.safetyAssessment;
    const savedAbnormalities = savedScoring.abnormalities;
    const normalizedSafetyAssessment = safetyAssessment && typeof safetyAssessment === 'object'
        ? { ...safetyAssessment }
        : {};
    const normalizedAbnormalities: { [findingKey: string]: any } = {};

    const normalizeLocationFinding = (finding: any) => ({
        ...finding,
        location: normalizeBrainSafetyLocation(finding.location),
        otherLocation: finding.otherLocation ?? finding.otherText ?? '',
    });

    LOCATION_FINDING_KEYS.forEach((findingKey) => {
        const finding = normalizedSafetyAssessment[findingKey];

        if (!finding || typeof finding !== 'object') {
            return;
        }

        normalizedSafetyAssessment[findingKey] = normalizeLocationFinding(finding);
    });

    ABNORMALITY_FINDING_KEYS.forEach((findingKey) => {
        const hasSplitFinding = savedAbnormalities
            && typeof savedAbnormalities === 'object'
            && Object.prototype.hasOwnProperty.call(savedAbnormalities, findingKey);
        const finding = hasSplitFinding
            ? savedAbnormalities[findingKey]
            : normalizedSafetyAssessment[findingKey];

        if (finding && typeof finding === 'object') {
            normalizedAbnormalities[findingKey] = findingKey === 'hydrocephalus'
                ? { ...finding }
                : normalizeLocationFinding(finding);
        }

        delete normalizedSafetyAssessment[findingKey];
    });

    return {
        ...savedScoring,
        safetyAssessment: normalizedSafetyAssessment,
        abnormalities: normalizedAbnormalities,
    };
}
